export default __webpack_public_path__ + "static/media/icon_settlement_inactive_new.beeaba78.svg";